import React from "react";
import { NextPage } from "next";

import SianGdpr from "scenes/SianGdpr";

const SianPage: NextPage = () => <SianGdpr />;

export default SianPage;
